import { useRouteError } from "react-router-dom";
import temp_image from './BlogFolder/img/blog-banner.png';
import { FaExclamationCircle } from "react-icons/fa";
import { BiSolidError } from "react-icons/bi";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <div className="blog-post-hero-section not-blog">
      <img className="contact-hero-image" alt="hero background" src={temp_image} />
      <div className="dark-overlay"></div>
      <div className="overall-blog-post-wrapper">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <BiSolidError /> Oops! An unexpected error occurred
        </h1>
      </div>
    </div>
  );
}
